// A `YYYY-MM-DD` date as day and short month, no year (`22 Oct`), the reading every offer date on
// a product surface uses: a promotion's end date (Pricing migration 18, ADO-2249) and a multi-buy
// deal's dates (Pricing migration 32, ADO-3985). Moved here from `pricing/priceExplanation.ts`
// so both share one reading.

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/**
 * `isoDate` as day and short month, no year (`11 Nov`), or `null` when it is not a real
 * `YYYY-MM-DD` date. Read from the digits, never through a time zone, so the day shown is the day
 * sent.
 */
export function formatDayMonth(isoDate: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (match === null) return null;
  const [year, month, day] = [Number(match[1]), Number(match[2]), Number(match[3])];
  if (month < 1 || month > 12 || day < 1) return null;
  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
  if (day > daysInMonth) return null;
  return `${day} ${MONTHS[month - 1]}`;
}
